import { Outlet, Navigate } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { KeyedRouteErrorBoundary } from '../RouteErrorBoundary';
import { useAuth } from '../../contexts/AuthContext';
import { useMobileAppShell } from '../../hooks/useIsMobile';
import { Loader2 } from 'lucide-react';
import { SiteAdSlot } from '../ads/SiteAdSlot';

export function ClientLayout() {
  const { user, loading } = useAuth();
  const mobileAppShell = useMobileAppShell();

  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${mobileAppShell ? 'mobile-app-container' : 'bg-gray-50'}`}>
        <div className={`flex flex-col items-center gap-4 ${mobileAppShell ? 'mobile-card p-8' : ''}`}>
          <Loader2 className="w-8 h-8 animate-spin text-teal-600" />
          {mobileAppShell && <span className="text-sm text-gray-500">Loading...</span>}
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (mobileAppShell) {
    return (
      <div className="mobile-app-container mobile-page">
        <Header />
        <SiteAdSlot slotKey="header" shell="member" />
        <main className="mobile-content">
          <SiteAdSlot slotKey="midRoll" shell="member" />
          <KeyedRouteErrorBoundary>
            <Outlet />
          </KeyedRouteErrorBoundary>
        </main>
        <SiteAdSlot slotKey="footer" shell="member" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <SiteAdSlot slotKey="header" shell="member" />
      {/* flex + min-h-0 so routes (e.g. team chat) can use flex-1 and not collapse to 0 height */}
      <main className="flex min-h-0 w-full min-w-0 flex-1 flex-col">
        <SiteAdSlot slotKey="midRoll" shell="member" />
        <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col">
          <KeyedRouteErrorBoundary>
            <Outlet />
          </KeyedRouteErrorBoundary>
        </div>
      </main>
      <SiteAdSlot slotKey="footer" shell="member" />
      <Footer />
    </div>
  );
}
